// frontend/src/pages/checkout/CancelPage.tsx
//
// 支付取消页（路由 /checkout/cancel）。

import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import CheckoutShell from './CheckoutShell';
import { notifyCheckoutResult, isEmbedded } from '../../utils/checkoutBridge';
import './checkout.css';

const CancelPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const paymentIntentId = searchParams.get('payment_intent');
  const embedded = isEmbedded();

  useEffect(() => {
    // 进入取消页即通知宿主（embedded / Flutter 场景）。
    notifyCheckoutResult('cancel', {
      payment_intent_id: paymentIntentId || undefined,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentIntentId]);

  const handleRetry = () => {
    if (paymentIntentId) {
      navigate(`/checkout/${paymentIntentId}`);
    } else {
      window.history.back();
    }
  };

  return (
    <CheckoutShell hideBrand={embedded}>
      <div className="fs-card fs-card--single">
        <div className="fs-result">
          <div className="fs-result-icon fs-result-icon--warning">
            <CloseOutlined />
          </div>
          <div className="fs-result-title">支付已取消</div>
          <div className="fs-result-subtitle">
            {paymentIntentId
              ? `订单 ${paymentIntentId} 的支付已被取消。如需继续，可重新发起支付。`
              : '您的支付已被取消。如需继续，可重新发起支付。'}
          </div>

          <div className="fs-result-actions">
            <Button type="primary" size="large" block onClick={handleRetry}>
              重试支付
            </Button>
            <Button size="large" block onClick={() => window.history.back()}>
              返回
            </Button>
          </div>
        </div>
      </div>
    </CheckoutShell>
  );
};

export default CancelPage;
